import { createFileRoute, redirect } from '@tanstack/react-router';

import { AppLayout, AppLayoutSkeleton } from '@layout';

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  pendingComponent: AppLayoutSkeleton,
  component: AppLayout,
});
